import { render } from "./ProjectDisplay.vue?vue&type=template&id=2df43fe1&scoped=true"
import script from "./ProjectDisplay.vue?vue&type=script&lang=js"
export * from "./ProjectDisplay.vue?vue&type=script&lang=js"

import "./ProjectDisplay.vue?vue&type=style&index=0&id=2df43fe1&scoped=true&lang=css"

import exportComponent from "/app/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2df43fe1"]])

export default __exports__